import React, { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import './FilterBar.css';

const FilterBar = ({
  selectedMUM,
  onMUMChange,
  selectedStore,
  onStoreChange,
  stores,
  mumList
}) => {
  const [localMumList, setLocalMumList] = useState(mumList || []);

  // Fetch MUM list if not provided
  useEffect(() => {
    if (!mumList) {
      fetchMUMs();
    }
  }, [mumList]);

  const fetchMUMs = async () => {
    try {
      const response = await apiClient.get('/api/mums');
      const data = response.data;
      const sortedMums = data.map(mum => mum.mum).sort();
      setLocalMumList(sortedMums);
    } catch (error) {
      console.error('Error fetching MUMs:', error);
    }
  };

  const handleMUMChange = (e) => {
    const value = e.target.value;
    onMUMChange(value);
    // Reset store selection when MUM changes
    onStoreChange('');
  };

  return (
    <div className="spreadsheet-filter-bar">
      <div className="filter-group">
        <label htmlFor="mum-select">MUM:</label>
        <select
          id="mum-select"
          value={selectedMUM}
          onChange={handleMUMChange}
          className="filter-select"
        >
          <option value="">Select MUM</option>
          {localMumList.map((mum, index) => (
            <option key={index} value={mum}>
              {mum}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="store-select">Store:</label>
        <select
          id="store-select"
          value={selectedStore}
          onChange={(e) => onStoreChange(e.target.value)}
          className="filter-select"
        >
          <option value="">All Stores</option>
          {stores.map((store, index) => (
            <option key={index} value={store.store_name}>
              {store.store_name}
            </option>
          ))}
        </select>
      </div>

      {selectedStore && (
        <button
          className="clear-filter-btn"
          onClick={() => onStoreChange('')}
          title="Clear store filter"
        >
          Clear Filter
        </button>
      )}
    </div>
  );
};

export default FilterBar;
